import notify from '@/components/notify';
import { errorHandler } from '../config';

const excludeCodes = [
  'REFRESH_TOKEN_INVALID',
  'REFRESH_TOKEN_EXPIRED',
  'CSRF_TOKEN_INVALID',
  'POST_IMPORT_FILE_MUST_BE_JSON',
];

interface Error {
  code: string,
  message: string,
}

errorHandler.onError((e: Error) => {
  if (excludeCodes.includes(e.code)) return;
  const message = e.message || `An unexpected error occurred. Code: ${e.code}`;
  notify({
    color: 'negative',
    message,
  });
});
